class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');

    if (this.isMegaMenu) {
      this.hoverCloseTimeout = null;
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.summary = this.mainDetailsToggle.querySelector('summary');

      this.onMegaMenuMouseEnter = this.handleMegaMenuMouseEnter.bind(this);
      this.onMegaMenuMouseLeave = this.handleMegaMenuMouseLeave.bind(this);
      this.onMegaMenuSummaryClick = this.handleMegaMenuSummaryClick.bind(this);

      this.addEventListener('mouseenter', this.onMegaMenuMouseEnter);
      this.addEventListener('mouseleave', this.onMegaMenuMouseLeave);
      this.summary.addEventListener('click', this.onMegaMenuSummaryClick);
    }
  }

  isDesktop() {
    return this.mediaQuery.matches;
  }

  handleMegaMenuMouseEnter() {
    if (!this.isDesktop()) return;

    clearTimeout(this.hoverCloseTimeout);
    this.closeSiblingMegaMenus();
    this.openMegaMenu();
  }

  handleMegaMenuMouseLeave() {
    if (!this.isDesktop()) return;

    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  handleMegaMenuSummaryClick(event) {
    if (!this.isDesktop()) return;
    event.preventDefault();
  }

  closeSiblingMegaMenus() {
    document.querySelectorAll('header-menu .mega-menu[open]').forEach((details) => {
      if (details === this.mainDetailsToggle) return;

      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  openMegaMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    clearTimeout(this.hoverCloseTimeout);
    super.close();
    if (this.header) this.header.preventHide = false;
  }
}

customElements.define('header-menu', HeaderMenu);
